/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";

// MRT
import { MaterialReactTable } from "material-react-table";

//import api requiremnts
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

// import Link
import { Link, useParams } from "react-router-dom";
//import translation function for language translation
import { useTranslation } from "react-i18next";

import UserProfileTabBreadCrumb from "../BreadCrumb/UserProfileTabBreadCrumb";

const ActivityTab = (props) => {
  const token = localStorage.getItem("token");
  const { screenHeight } = useContext(GlobalProvider);
  const params = useParams();

  const { t } = useTranslation(); //for translation
  const [activityData, setActivityData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  //function for get all reservation list
  const getAllReservationList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_ACTIVITY_EVENTS +
        `?token=${token}&personid=${params.id}`;

      console.log("reserve list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log(
        "reserve list response profile activity tab ========>>>",
        response
      );

      if (response.data) {
        setActivityData(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  const tableColumns = useMemo(
    () => [
      {
        id: "name",
        accessorKey: "name",
        header: t("Name"),
        size: 400,
      },
      {
        id: "code",
        accessorKey: "code",
        header: t("Code"),
        size: 200,
      },
      {
        id: "reservecounts",
        accessorKey: "reservecounts",
        header: t("Participation Count"),
        size: 200,
      },
    ],
    [activityData]
  );

  useEffect(() => {
    getAllReservationList();
  }, []);

  return (
    <div className="profile_tabInnr">
      <UserProfileTabBreadCrumb
        moduleName="Activity"
        userData={props?.userData}
      />

      {/* ======================== Grid view start =========================== */}
      <MaterialReactTable
        columns={tableColumns}
        data={activityData}
        enableSorting
        enableFilters
        enableGlobalFilter={false}
        enableGrouping
        enableColumnOrdering
        enableStickyHeader
        enableRowSelection
        onRowSelectionChange={setRowSelection}
        getRowId={(row) => row._id}
        state={{ rowSelection }}
        muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
        muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
        muiTableBodyProps={{ sx: { overflow: "visible" } }}
        initialState={{
          pagination: { pageSize: 100, pageIndex: 0 },
          showColumnFilters: true,
        }}
      />
      {/* ======================== Grid view end =========================== */}
    </div>
  );
};

export default ActivityTab;
